/* eslint-disable no-console */
import Api from "../../../api";
import getReportPresenter from "../presenters";
import getReportSchema from "../schemas";

const url = "/reports";

const getReport = {
  state: {
    data: null,
  },
  reducers: {
    resetData(state) {
      return {
        ...state,
        data: null,
      };
    },
    setReportData(state, payload) {
      return {
        ...state,
        data: payload,
      };
    },
  },
  effects: (dispatch) => ({
    async getReportById(id) {
      try {
        dispatch.notification.clearAll();
        dispatch.getReport.resetData();

        const fetchResponse = await Api.get(`${url}/${id}`);
        // console.log("Fetch response", fetchResponse.data);

        const schemaIsValid = await getReportSchema.isValid(fetchResponse.data);
        // console.log(getReportSchema.validate(fetchResponse.data));
        // console.log("Schema is valid?", schemaIsValid);

        if (schemaIsValid) {
          dispatch.getReport.setReportData(
            getReportPresenter(fetchResponse.data)
          );
        } else {
          dispatch.notification.setErrorMessage("Respon tidak sesuai");
        }
      } catch (error) {
        if (error.response) {
          // Request made and server responded
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);

          // Set error messages
          if (
            error.response.status === 404 &&
            error.response.data.code === "not_found"
          ) {
            dispatch.notification.setErrorMessage(
              "Laporan Anda tidak dapat ditemukan/bersifat privasi dan tidak dapat di lihat publik\n\nMohon periksa kembali nomor laporan yang Anda masukkan atau silahkan cek kembali laporan privasi Anda di Aplikasi JAKI\nuntuk informasi lebih lanjut dapat hubungi Admin Jakarta Smart City.\n\n--\nAdmin JSC\n\nEmail: dki@jakarta.go.id"
            );
          } else {
            dispatch.notification.setErrorMessage(error.response.data.message);
          }
        } else if (error.request) {
          // The request was made but no response was received
          console.log(error.request);

          // Set error messages
          dispatch.notification.setErrorMessage(
            "Gagal melakukan permintaan data"
          );
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log(error.message);
        }
      }
    },
  }),
};

export default getReport;
